module.exports = __webpack_public_path__ + "img/cdkf1.c57ddc83.jpg";